<section class="adaline-publish" dir="rtl" aria-labelledby="adaline-publish-title">
  <header class="adaline-header">
    <div class="adaline-identity">
      <span class="adaline-avatar" aria-hidden="true">A</span>
      <span>
        <strong id="adaline-publish-title">Adaline</strong>
        <small><i></i> עוזרת הפרסום החכמה</small>
      </span>
    </div>
    <button type="button" class="manual-switch" (click)="switchToManual()">
      <mat-icon aria-hidden="true">edit_note</mat-icon>
      <span>לטופס הידני</span>
    </button>
  </header>

  <div class="adaline-progress" aria-label="התקדמות מילוי המודעה">
    <div class="progress-copy">
      <span>{{ isComplete ? 'הפרטים מוכנים' : 'שאלה ' + (currentIndex + 1) + ' מתוך ' + orderedQuestions.length }}</span>
      <strong>{{ progressPercent }}%</strong>
    </div>
    <span class="progress-track"><i [style.width.%]="progressPercent"></i></span>
  </div>

  <div class="adaline-conversation">
    <div class="chat-row chat-row--bot welcome-row">
      <span class="message-avatar" aria-hidden="true">A</span>
      <div class="chat-bubble chat-bubble--bot">
        <strong>מצוין, מתחילים{{ categoryLabel ? ' עם ' + categoryLabel : '' }}!</strong>
        <p>אשאל את אותן שאלות שמופיעות בטופס הידני ואשמור כל תשובה ישירות במודעה.</p>
      </div>
    </div>

    @for (item of history; track trackHistory($index, item)) {
      <div class="history-pair">
        <div class="chat-row chat-row--bot compact-row">
          <span class="message-avatar" aria-hidden="true">A</span>
          <div class="chat-bubble chat-bubble--bot">{{ item.question }}</div>
        </div>
        <div class="chat-row chat-row--user">
          <button type="button" class="chat-bubble chat-bubble--user history-answer" (click)="editHistory(item)" title="עריכת התשובה">
            <span>{{ item.answer }}</span>
            <mat-icon aria-hidden="true">edit</mat-icon>
          </button>
        </div>
      </div>
    }

    @if (currentQuestion; as question) {
      <div class="chat-row chat-row--bot current-prompt">
        <span class="message-avatar" aria-hidden="true">A</span>
        <div class="chat-bubble chat-bubble--bot">
          <span class="section-kicker">{{ sectionLabel }}</span>
          <strong>{{ getStepLabel(question) }}</strong>
          @if (isCarIdentificationQuestion(question)) { <small>אפשר לאתר לפי מספר רישוי או להזין ידנית</small> }
          @else if (question.required) { <small>שדה חובה</small> }
          @else { <small>אפשר לדלג אם לא רלוונטי</small> }
          <!-- SCRUM-155: field guidance -->
          @if (question.hint) {
            @for (line of question.hint.split('\n'); track $index) { <small class="hint-line">{{ line }}</small> }
          }
        </div>
      </div>

      @for (activeQuestion of [question]; track activeQuestion.key) {
        <div
          class="adaline-current-control"
          [class.adaline-current-control--feature]="isCarIdentificationQuestion(activeQuestion)"
          [attr.data-question-key]="activeQuestion.key">
          @if (isCarIdentificationQuestion(activeQuestion)) {
            <app-car-type
              [section]="getCarSection(activeQuestion)"
              [questions]="getCarSectionQuestions(activeQuestion)"
              [form]="form">
            </app-car-type>
          } @else {
            <app-question [question]="activeQuestion" [form]="form"></app-question>
          }
          @if (validationVisible && !canContinue) {
            <div class="adaline-validation" role="alert">
              <mat-icon aria-hidden="true">info</mat-icon>
              <span>צריך להשלים את השדה לפני שממשיכים</span>
            </div>
          }
        </div>
      }

      @if (isThinking) {
        <div class="chat-row chat-row--bot adaline-thinking" role="status" aria-live="polite" aria-label="Adaline מכינה את השאלה הבאה">
          <span class="message-avatar" aria-hidden="true">A</span>
          <span class="thinking-bubble" aria-hidden="true"><i></i><i></i><i></i></span>
        </div>
      }

      <nav class="adaline-actions" aria-label="ניווט בין שאלות">
        <button type="button" class="secondary-action" [disabled]="currentIndex === 0" (click)="previous()">
          <mat-icon aria-hidden="true">arrow_forward</mat-icon>
          <span>הקודם</span>
        </button>
        <button type="button" class="primary-action" [disabled]="isThinking" (click)="next()">
          <span>{{ question.required || currentHasAnswer ? 'שמירה והמשך' : 'דלג' }}</span>
          <mat-icon aria-hidden="true">arrow_back</mat-icon>
        </button>
      </nav>
    }

    @if (isComplete) {
      <div class="adaline-completion">
        <span class="completion-icon" aria-hidden="true"><mat-icon>check</mat-icon></span>
        <h2>סיימנו את פרטי המודעה</h2>
        <p>אפשר לבחור עכשיו את מסלול הפרסום. תמיד ניתן לחזור לטופס הידני ולבדוק את התשובות.</p>
        <button type="button" class="review-button" (click)="switchToManual()">
          <mat-icon aria-hidden="true">visibility</mat-icon>
          <span>בדיקת הפרטים בטופס</span>
        </button>
      </div>

      <div class="adaline-route">
        <app-select-route [greenPass]="requiredComplete"></app-select-route>
      </div>
    }
  </div>
</section>
